import React from 'react';
import { hot } from 'react-hot-loader';
import { urlify } from '../../../utils/string';
import s from './Radio.scss';

const Radio = ({ variantClasses = [], id, options, selected, inputChange, label = null, isError = false, ...props }) => {
	const inputChangeHandler = (e) => {
		const value = e.target.value;
		inputChange(value);
	};

	const radioClasses = [s.radio];
	const labelClasses = [s.label];

	if (!Array.isArray(variantClasses)) variantClasses = [variantClasses.toString()];
	variantClasses.filter((c) => !!c).forEach((c) => {
		if (c.indexOf('label') !== -1) labelClasses.push(s[c]);
		else radioClasses.push(s[c]);
	});

	if (isError) {
		radioClasses.push(s.radio__error);
		labelClasses.push(s.radio__error);
	}

	const choices = options.map((option) => {
		const key = urlify(option.key);
		const classes = [...radioClasses];
		if (option.key === selected || option.selected) classes.push(s.radio__selected);
		if (option.disabled) classes.push(s.radio__disabled);

		return (
			<label key={key} htmlFor={`${id}_${key}`} className={classes.join(' ')}>
				<input className={s.radio_input} id={`${id}_${key}`} type="radio" name={id} value={option.key} disabled={option.disabled} checked={option.key === selected} onChange={inputChangeHandler} {...props} />
				<span /><span className={s.radio_content}>{ option.value }</span>
				{ option.info ? <p className={s.radio_info}>{option.info}</p> : null }
			</label>
		);
	});

	if (label) {
		return (
			<div className={labelClasses.join(' ')}>
				<span className={s.label_label}>{ label }</span>
				{ choices }
			</div>
		);
	}

	return choices;
};

export default hot(module)(Radio);
